
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { getCompanyAddressInfo, ShopAddressListDto } from "@/api/buyCar";
import { editCompanyAddressInfo, deleteCompanyAddressInfo } from "@/api/my";

@Component
export default class AddressManage extends Vue {
  @Getter companyId!: string;
  chosenAddressId = "";
  listData: any[] = [];

  isLoading = false;

  async onDefault(item) {
    if (this.isLoading) return;
    this.isLoading = true;
    const params = {
      autoId: item.autoId,
      isDefault: item.isDefault ? 1 : 0,
    };
    editCompanyAddressInfo(params)
      .then((res) => {
        if (res.code === "000000") {
          this.$toast("设置成功");
          this.getAddressInfo();
        } else {
          item.isDefault = !item.isDefault;
        }
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
        item.isDefault = !item.isDefault;
      });
  }
  // 添加
  onAdd() {
    this.$router.push({ name: "EditAddress" });
  }
  onEdit(item: any) {
    this.$router.push({
      name: "EditAddress",
      query: {
        autoId: item.autoId,
      },
    });
  }
  // 删除
  onDel(item: any) {
    this.$confirmDialog.show({
      okText: "确认",
      cancelText: "取消",
      tips: "确认删除吗?",
      onOk: () => {
        return this.delFunc(item.autoId);
      },
    });
  }

  delFunc(autoId) {
    if (this.isLoading) return;
    this.isLoading = true;
    const params = {
      autoId,
    };
    deleteCompanyAddressInfo(params)
      .then((res) => {
        this.$notify({
          type: "success",
          message: "删除成功！",
        });
        this.getAddressInfo();
        this.isLoading = false;
      })
      .catch(() => {
        this.$toast("删除失败");
        this.isLoading = false;
      });
  }

  /* 获取地址信息 */
  async getAddressInfo() {
    const res = await getCompanyAddressInfo({ companyId: this.companyId });
    if (res.data.addressList && res.data.addressList.length > 0) {
      this.listData = res.data.addressList.map((item) => {
        return {
          ...item,
          isDefault: item.isDefault === 1,
        };
      });
    }
  }
  created() {
    this.getAddressInfo();
  }
}
